import comp from "./GradeList";
export default comp;
